import {create} from "zustand";

const useBetbyStore = create(set => ({
  tokenBetby: null,
  betbyList: [],
  setBetbyList: list => set(state => ({...state, betbyList: list})),
  setTokenBetby: tokenBetby => set(state => ({...state, tokenBetby})),
}));

export default useBetbyStore;
